import { create } from 'zustand';

interface PortOrderState {
  // Selected port order for detail/timeline drawer
  selectedPortId: number | null;
  isDrawerOpen: boolean;

  // Selected port order for manifest drawer (DID list)
  manifestPortId: number | null;
  manifestDids: string[];
  isManifestOpen: boolean;

  // Actions
  openDrawer: (portId: number) => void;
  closeDrawer: () => void;
  openManifest: (portId: number, dids: string[]) => void;
  closeManifest: () => void;
}

export const usePortOrderStore = create<PortOrderState>((set) => ({
  // Initial state
  selectedPortId: null,
  isDrawerOpen: false,
  manifestPortId: null,
  manifestDids: [],
  isManifestOpen: false,

  // Actions
  openDrawer: (portId) =>
    set({
      selectedPortId: portId,
      isDrawerOpen: true,
    }),

  closeDrawer: () =>
    set({
      selectedPortId: null,
      isDrawerOpen: false,
    }),

  openManifest: (portId, dids) =>
    set({
      manifestPortId: portId,
      manifestDids: dids,
      isManifestOpen: true,
    }),

  closeManifest: () =>
    set({
      manifestPortId: null,
      manifestDids: [],
      isManifestOpen: false,
    }),
}));
